

export default {
    API: {
        EVENTS_LIST: 'events/list',
        EVENT: '/event'
    },
    FORMAT: {
        DATETIME: {
            YYYYMMDDHHmmss: 'YYYY/MM/DD HH:mm:ss',
            YYYYMMDD: 'YYYY/MM/DD',
            HHmm: 'HH:mm'
        }
    },
    API_RESULT: {
        OK: 'OK',
        NG: 'NG'
    }
}